import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { available } from './availableAction';

export const outputActions = [available];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
